import React from 'react'
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    HStack,
    Text,
    Link,
    Flex,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ReturnIcon, EmailIcon} from '../../../components/icons'
import {useIntl} from 'react-intl'
import useUtils from '../../../custom-hooks/use-utils-helper'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import routingObject from '../../../utils/static-routes'
import {useCustomPreference} from '../../../hooks/use-custom-preference'

const CART_POLICY_ITEMS = [
    {
        key: 'gift-note',
        Icon: EmailIcon,
        title: {
            id: 'cart_default.cart_policies.gift_title',
            defaultMessage: 'Gift Note',
        },
        message: {
            id: 'cart_default.cart_policies.gift_message',
            defaultMessage:
                'If it’s a gift, you can write a personalized greeting card at the checkout',
        },
        isVisible: ({isCart, isGiftNoteVisible}) =>
            isCart && isGiftNoteVisible?.showNoteFlag === 'true',
    },
    {
        key: 'return',
        Icon: ReturnIcon,
        title: {
            id: 'cart_default.cart_policies.return_title',
            defaultMessage: 'Return',
        },
        message: {
            id: 'cart_default.cart_policies.return_message',
            defaultMessage:
                'You can return items purchased on our official website within 30 days of their shipment for a full refund of the purchase price. {link}',
        },
        getMessageValues: ({buildUrl, formatMessage, policies}) => ({
            link: (
                <Link
                    {...policies?.link}
                    href={buildUrl(routingObject.FAQ_PATH)}
                    aria-label={formatMessage({
                        id: 'cart_default.cart_policies.faq_link',
                        defaultMessage: 'Read more about our return policy in FAQ',
                    })}
                >
                    FAQ
                </Link>
            ),
        }),
    },
]

const CartPolicies = () => {
    const style = useMultiStyleConfig('Cart', {})
    const {formatMessage} = useIntl()
    const {policies} = style
    const {isCart} = useUtils().currentPage(location.pathname)
    const {buildUrl} = useMultiSite()
    const isGiftNoteVisible = useCustomPreference('showNoteFlag')
    const visiblePolicyItems = CART_POLICY_ITEMS.filter(
        ({isVisible}) =>
            !isVisible ||
            isVisible({
                isCart,
                isGiftNoteVisible,
            }),
    )

    return (
        <Flex {...policies?.outerContainer}>
            {visiblePolicyItems.map(({key, Icon, title, message, getMessageValues}) => (
                <Accordion key={key} allowToggle {...policies?.policiesContainer}>
                    <AccordionItem border="none" {...policies?.section}>
                        <AccordionButton px={0} py={0} _hover={{bg: 'transparent'}}>
                            <HStack flex="1" {...policies?.header}>
                                <Icon {...policies?.icon} aria-hidden="true" />

                                <Text {...policies?.title}>{formatMessage(title)}</Text>
                            </HStack>

                            <AccordionIcon />
                        </AccordionButton>

                        <AccordionPanel px={0} pt={0} pb={0}>
                            <Text {...policies?.message}>
                                {formatMessage(
                                    message,
                                    getMessageValues?.({
                                        buildUrl,
                                        formatMessage,
                                        policies,
                                    }),
                                )}
                            </Text>
                        </AccordionPanel>
                    </AccordionItem>
                </Accordion>
            ))}
        </Flex>
    )
}

export default CartPolicies
